import { Sigma } from "lucide-react";
import { useLanguage } from "../../contexts/LanguageContext";

/** Il totale IPF del profilo, se il server l'ha calcolato (lo porta ogni alzata di gara). */
export function findIpfTotal(domains) {
	for (const domain of Array.isArray(domains) ? domains : []) {
		for (const exercise of domain?.exercises || []) {
			if (exercise?.ipf_total) return exercise.ipf_total;
		}
	}
	return null;
}

export function formatDecimal(value, language, digits = 2) {
	const number = Number(value);
	if (!Number.isFinite(number)) return "";
	return number.toLocaleString(language === "en" ? "en-US" : "it-IT", {
		maximumFractionDigits: digits,
	});
}

/**
 * Il totale delle tre alzate e i suoi punti IPF GL (D6b di docs/sport-config).
 *
 * La federazione definisce i punti GL per il totale e per la panca, non per
 * squat e stacco da soli: il totale e' quindi l'unico numero che dice quanto
 * vale un powerlifter rispetto al suo peso. Lo calcola il server, solo quando
 * il modello usa l'IPF GL e le tre alzate di gara hanno un valore; altrimenti
 * questa riga non c'e'. Una riga sola, per stare anche sul telefono.
 */
export function IpfTotalLine({ domains }) {
	const { t, language } = useLanguage();
	const total = findIpfTotal(domains);
	if (!total) return null;
	return (
		<div
			className="flex flex-wrap items-center gap-x-2 gap-y-1 rounded-sm border border-border bg-secondary/30 px-3 py-2 text-xs"
			data-testid="ipf-total"
		>
			<Sigma className="w-3.5 h-3.5 text-volt shrink-0" />
			<span className="text-muted-foreground">{t("ipfTotalLabel")}</span>
			<span className="font-medium text-foreground">
				{formatDecimal(total.total, language, 1)} kg
			</span>
			<span className="text-muted-foreground">·</span>
			<span className="font-medium text-foreground">
				{t("ipfGlPoints").replace("{points}", formatDecimal(total.points, language))}
			</span>
			<span className="text-muted-foreground">
				{t(total.equipment === "equipped" ? "ipfEquipped" : "ipfClassic")}
			</span>
		</div>
	);
}
